import { reduxForm } from "redux-form";

import RoomForm from "./RoomForm";
import StyleForm from "./StyleForm";
import SizeForm from "./SizeForm";
import DesignForm from "./DesignForm";
import ColourForm from "./ColourForm";
import HandleForm from "./HandleForm";
import EfficiencyForm from "./EfficiencyForm";

import validate from "./validate";

export const Room = {
    name: "Room",
    form: reduxForm({
        form: "WindowWizard",
        destroyOnUnmount: false,
        // forceUnregisterOnUnmount: true,
        keepDirtyOnReinitialize: true,
        enableReinitialize: true,
        validate
    })(RoomForm)
};

export const Style = {
    name: "Style",
    form: StyleForm
};

export const Size = {
    name: "Size",
    form: SizeForm
};

export const Design = {
    name: "Design",
    form: reduxForm({
        form: "WindowWizard",
        destroyOnUnmount: false,
        // forceUnregisterOnUnmount: true,
        keepDirtyOnReinitialize: true,
        enableReinitialize: true,
        validate
    })(DesignForm)
};

export const Colour = {
    name: "Colour",
    form: reduxForm({
        form: "WindowWizard",
        destroyOnUnmount: false,
        // forceUnregisterOnUnmount: true,
        keepDirtyOnReinitialize: true,
        enableReinitialize: true,
        validate
    })(ColourForm)
};

export const Handle = {
    name: "Handles",
    form: reduxForm({
        form: "WindowWizard",
        destroyOnUnmount: false,
        // forceUnregisterOnUnmount: true,
        keepDirtyOnReinitialize: true,
        enableReinitialize: true,
        validate
    })(HandleForm)
};

export const Efficiency = {
    name: "Other",
    form: reduxForm({
        form: "WindowWizard",
        destroyOnUnmount: false,
        // forceUnregisterOnUnmount: true,
        keepDirtyOnReinitialize: true,
        enableReinitialize: true,
        validate
    })(EfficiencyForm)
};



// WEBPACK FOOTER //
// ./src/containers/WindowForm/index.js